<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="组织机构" prop="orgCode">
            <org-cascader
              filterable
              style="width: 100%"
              :lastValue.sync="formData.orgCode"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: { type: Boolean, default: false },
    clientCode: { type: String, default: '' },
    clientOrgScopeCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { orgCode: '' },
      rules: {
        orgCode: [
          {
            required: true,
            message: '请选择组织机构',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.clientOrgScopeCode) return

      this.$api
        .sysOpenapiClientOrgScopeDetailApi({
          clientOrgScopeCode: this.clientOrgScopeCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .sysOpenapiClientOrgScopeSaveApi({
          ...this.formData,
          clientCode: this.clientCode,
        })
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm('是否要保存更改', '提示信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '保存',
        cancelButtonText: '不保存',
      })
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
